export default __webpack_public_path__ + "static/media/health_and_safety.67a6e6d6.svg";